// var dontShowLengthConductors = 10;

// TODO HARIM
// TODO BRACKET
// TODO LAMP
// TODO trans

import { LineDrawer } from './LineDrawer';
import { PoleDrawer } from './PoleDrawer';
import { TransDrawer } from './TransDrawer';

const Drawer = {


    drawAllMvPoles(mymap, data) {
        for (var i = 0; i < data.polesArr.length; i++) {
            if (data.polesArr[i]['height'] == 12 || data.polesArr[i]['height'] == 15)
                this.dPole(mymap, data.polesArr[i], "");
        }
    },
    drawAllTrans(mymap, data) {

        for (var i = 0; i < data.a_sub.length; i++) {
            // linesArr[i]["_LINES"]
            this.dTrans(mymap, data.a_sub[i], "");
        }
        for (i = 0; i < data.l_sub.length; i++) {
            // linesArr[i]["_LINES"]
            this.dTrans(mymap, data.l_sub[i], "");
        }
    },
    drawAll(mymap, data) {
        let drawnData = {
            linesArr: [],
            polesArr: [],
            transArr: [],
        };
        if (data.linesArr)
            for (var i = 0; i < data.linesArr.length; i++) {
                drawnData.linesArr.push(this.dLine(mymap, data.linesArr[i]));
                drawnData.linesArr
            }
        if (data.polesArr)
            for (i = 0; i < data.polesArr.length; i++) {
                drawnData.polesArr.push(this.dPole(mymap, data.polesArr[i], ""));
            }
        if (data.a_sub)
            for (i = 0; i < data.a_sub.length; i++) {
                drawnData.transArr.push(this.dTrans(mymap, data.a_sub[i], ""));
            }
        if (data.l_sub)
            for (i = 0; i < data.l_sub.length; i++) {
                // TODO trans L is different
                drawnData.transArr.push(this.dTrans(mymap, data.l_sub[i], ""));
            }

            return drawnData;
    },

    dLine: function (mymap, lineRow) {
        if(lineRow.n_spec!="Cable Service" && lineRow.n_spec.split("_Cable_").length==1)
        return LineDrawer.draw(mymap, lineRow);
        return null;
    },

    dPole: function (mymap, poleRow) {
        return PoleDrawer.draw(mymap, poleRow);
    },
    dTrans: function (mymap, transPole) {
        return TransDrawer.draw(mymap, transPole);
    },

};



// function rotate_point(pointX, pointY, originX, originY, angle) {
//     angle = angle * Math.PI / 180.0;
//     return {
//         x: Math.cos(angle) * (pointX-originX) - Math.sin(angle) * (pointY-originY) + originX,
//         y: Math.sin(angle) * (pointX-originX) + Math.cos(angle) * (pointY-originY) + originY
//     };
// }



export { Drawer };








